// @flow
import { API } from 'api/api'
import { makeGetRequest } from 'api/fetchCalls'
import type { ResourceSettings } from 'types/resource-settings'

const loadResourcesSettings = async (
  id: string
): Promise<ResourceSettings> | {} => {
  return await makeGetRequest(API.FORM_BUILDER.RESOURCE_SETTINGS_ID(id))
}

export default loadResourcesSettings
